export default __webpack_public_path__ + "static/media/fight.39aa326b.png";